import React, { useEffect, useState } from "react";
import SideBar from "./SideBar";
import TopNav from "../TopNav";
import Footer from "../Footer";
import { API_URL } from "../config";

const PosGas = () => {
  const [branches, setBranches] = useState([]);
  const [companyId, setCompanyId] = useState();

  // Set companyId only once on mount
  useEffect(() => {
    const companyIdFromLocalStorage = localStorage.getItem("company_id");
    setCompanyId(companyIdFromLocalStorage);
  }, []);

  // Fetch branches based on company ID
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await fetch(
          `${API_URL}/branches/company/${companyId}`
        );
        const branchesData = await response.json();
        console.log("Branches fetched:>>>>>>>>>>>>>>>>>>>>>>>>>>>", branchesData); // Debugging
        setBranches(branchesData);

        // After fetching branches, fetch payments for each branch
        const branchIds = branchesData.map(branch => branch.branch_id);
        fetchBranchesData(branchIds);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };

    if (companyId) {
      fetchBranches();
    }
  }, [companyId]);

  const fetchBranchesData = async (branchIds) => {
    try {
      const responses = await Promise.all(
        branchIds.map(async (branchId) => {
          const res = await fetch(`${API_URL}/payments/branch/${branchId}/${companyId}`);
          const data = await res.json();
          console.log(`Data from Branch ID ${branchId}:`, data); // Log all fields for the branch
          return data;
        })
      );

      const allBranchesData = responses.flat();
      setBranches(prevBranches => {
        // Merge fetched data with branches
        return prevBranches.map(branch => {
          const paymentData = allBranchesData.find(data => data.branch_id === branch.branch_id);
          return {
            ...branch,
            ...paymentData // Merge both branch and payment data
          };
        });
      });
    } catch (error) {
      console.error("Error fetching branches data:", error);
    }
  };

  return (
    <div>
      <html>
        <head>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
          <title>Concept - Bootstrap 4 Admin Dashboard Template</title>
          <link rel="stylesheet" href="../assets/vendor/bootstrap/css/bootstrap.min.css" />
          <link href="../assets/vendor/fonts/circular-std/style.css" rel="stylesheet" />
          <link rel="stylesheet" href="../assets/libs/css/style.css" />
          <link rel="stylesheet" href="../assets/vendor/fonts/fontawesome/css/fontawesome-all.css" />
        </head>

        <body>
          <div className="dashboard-main-wrapper">
            <TopNav />
            <SideBar />

            <div className="dashboard-wrapper">
              <div className="container-fluid dashboard-content">
                <div className="row" style={{ marginLeft: "1%", textAlign: "center" }}>
                  <h5 className="header" style={{ fontFamily: "sans-serif" }}>
                    Remote View
                  </h5>

                  {branches.map((option) => (
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12" key={option.branch_id}>
                      <div className="card">
                        <div className="card-body">
                          <h4 className="text-muted" style={{ fontFamily: "sans-serif", fontWeight: "bold" }}>
                            {option.branch_name || "Loading..."} <br></br>(Branch ID: {option.branch_id})
                          </h4>
                          <div className="metric-value d-inline-block text-end" style={{ fontFamily: "sans-serif" }}>

                            <div className="row">
                              <div className="col-xl-6 col-md-6 col-6">
                                <h6 className="mb-1" style={{ fontSize: "15px", textAlign: "left", fontFamily: "sans-serif" }}>
                                  Operator Name:
                                </h6>
                              </div>
                              <div className="col-xl-6 col-md-6 col-6">
                                <h6 className="mb-1" style={{ fontSize: "15px", fontFamily: "sans-serif" }}>
                                  {option.username}
                                </h6>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 col-md-6 col-6">
                                <h6 className="mb-1" style={{ fontSize: "15px", textAlign: "left", fontFamily: "sans-serif", fontWeight: "bold", color: "blue", fontSize: "20px" }}>
                                  Sold Stock:
                                </h6>
                              </div>
                              <div className="col-xl-6 col-md-6 col-6">
                                <h6 className="mb-1" style={{ fontSize: "15px", textAlign: "right", fontFamily: "sans-serif", fontWeight: "bold", color: "blue", fontSize: "20px" }}>
                                  {option.quantity} KG
                                </h6>
                              </div>
                            </div>
                            {/* Additional fields */}
                            <div className="row">
                              <div className="col-xl-6 col-md-6 col-6">
                                <h6 className="mb-1" style={{ fontSize: "15px", textAlign: "left", fontFamily: "sans-serif" }}>
                                  Amount CAS(bond notes):
                                </h6>
                              </div>
                              <div className="col-xl-6 col-md-6 col-6">
                                <h6 className="mb-1" style={{ fontSize: "15px", fontFamily: "sans-serif" }}>
                                  {option.amnt_cas} ZWL
                                </h6>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 col-md-6 col-6">
                                <h6 className="mb-1" style={{ fontSize: "15px", textAlign: "left", fontFamily: "sans-serif" }}>
                                  Amount ECO Cash:
                                </h6>
                              </div>
                              <div className="col-xl-6 col-md-6 col-6">
                                <h6 className="mb-1" style={{ fontSize: "15px", fontFamily: "sans-serif" }}>
                                  {option.amnt_eco} ZWL
                                </h6>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 col-md-6 col-6">
                                <h6 className="mb-1" style={{ fontSize: "15px", textAlign: "left", fontFamily: "sans-serif" }}>
                                  Amount USD:
                                </h6>
                              </div>
                              <div className="col-xl-6 col-md-6 col-6">
                                <h6 className="mb-1" style={{ fontSize: "15px", fontFamily: "sans-serif" }}>
                                  {option.amnt_usd} USD
                                </h6>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 col-md-6 col-6">
                                <h6 className="mb-1" style={{ fontSize: "15px", textAlign: "left", fontFamily: "sans-serif" }}>
                                  Amount ZIP IT:
                                </h6>
                              </div>
                              <div className="col-xl-6 col-md-6 col-6">
                                <h6 className="mb-1" style={{ fontSize: "15px", fontFamily: "sans-serif" }}>
                                  {option.amnt_zpt} USD
                                </h6>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 col-md-6 col-6">
                                <h6 className="mb-1" style={{ fontSize: "15px", textAlign: "left", fontFamily: "sans-serif" }}>
                                  Amount ZAR:
                                </h6>
                              </div>
                              <div className="col-xl-6 col-md-6 col-6">
                                <h6 className="mb-1" style={{ fontSize: "15px", fontFamily: "sans-serif" }}>
                                  {option.amnt_zar} ZAR
                                </h6>
                              </div>
                            </div>
                            {/* Button for redirecting to URL */}
                            <div className="row">
                              <div className="col-12">
                                {option.branch_software_target_url_address ? (
                                  <a href={option.branch_software_target_url_address} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                                    Visit Branch
                                  </a>
                                ) : (
                                  <button className="btn btn-secondary" disabled>
                                   Direct Branch Access Configuired.
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div id="sparkline-revenue"></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div style={{ width: "100%", float: "right" }}>
              <Footer />
            </div>
          </div>
          <script src="../assets/vendor/jquery/jquery-3.3.1.min.js"></script>
          <script src="../assets/vendor/bootstrap/js/bootstrap.bundle.js"></script>
          <script src="../assets/vendor/slimscroll/jquery.slimscroll.js"></script>
          <script src="../assets/libs/js/main-js.js"></script>
        </body>
      </html>
    </div>
  );
};

export default PosGas;